module.exports = "<p>\r\n  print-report-logs works!\r\n</p>\r\n"